import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const FileUploadArea = ({ label, description, accept, onChange, error, required }) => {
  const [fileName, setFileName] = useState('');
  const [isDragging, setIsDragging] = useState(false);

  const handleFileChange = (e) => {
    const file = e?.target?.files?.[0];
    if (file) {
      setFileName(file?.name);
      onChange && onChange(file);
    }
  };

  const handleDragOver = (e) => {
    e?.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e?.preventDefault();
    setIsDragging(false);
    const file = e?.dataTransfer?.files?.[0];
    if (file) {
      setFileName(file?.name);
      onChange && onChange(file);
    }
  };

  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm font-medium text-foreground mb-2">
          {label}
          {required && <span className="text-error ml-1">*</span>}
        </label>
      )}
      {description && (
        <p className="text-sm text-muted-foreground mb-3">{description}</p>
      )}
      
      <div
        className={`relative border-2 border-dashed rounded-lg p-6 transition-all duration-250 ${
          isDragging 
            ? 'border-primary bg-primary/5' 
            : error 
            ? 'border-error bg-error/5' :'border-border hover:border-primary/50'
        }`}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
      >
        <input
          type="file"
          accept={accept}
          onChange={handleFileChange}
          className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
        />
        
        <div className="flex flex-col items-center justify-center text-center">
          <div className="w-12 h-12 rounded-full bg-muted flex items-center justify-center mb-3">
            <Icon name="Upload" size={24} color="var(--color-muted-foreground)" />
          </div>
          
          {fileName ? (
            <div className="flex items-center gap-2 text-sm text-foreground">
              <Icon name="FileText" size={16} color="var(--color-success)" />
              <span className="font-medium">{fileName}</span>
            </div>
          ) : (
            <>
              <p className="text-sm font-medium text-foreground mb-1">
                Klik untuk unggah atau seret file ke sini
              </p>
              <p className="text-xs text-muted-foreground">
                {accept || 'Semua format file didukung'}
              </p>
            </>
          )}
        </div>
      </div>
      
      {error && (
        <p className="text-sm text-error mt-2">{error}</p>
      )}
    </div>
  );
};

export default FileUploadArea;